var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"fill":"none","stroke":"#FFF","stroke-miterlimit":"10","d":"M5.5 7.5h9M5.5 10h9M5.5 12.5h9"}})])}
var staticRenderFns = []

export { render, staticRenderFns }